<template>
  <div class="bigBox">
    <div class="flexCss">
      <el-image class="left" fit="fill" :src='copyRight.photo'>
        <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <div class="right">
          <h1>{{copyRight.msg}}</h1>
          <h2 class="tip">{{copyRight.title}}</h2>
          <p class="phone">{{copyRight.head}}：{{copyRight.phone}}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { mapState } from "vuex";
export default {
  name: 'login',
  data() {
    return {

    }
  },
   computed: {
    ...mapState(['copyRight']),
  },
  // 创建完毕状态(里面是操作)
  created() {
  },
  // 里面的函数只有调用才会执行
  methods: {
  }
}
</script>

<style scoped lang='less'>
.bigBox{
    // height: 100%;
    // text-align: center;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    font-family: "Nunito Sans";
    color: var(--blue);
    font-size: 1em;
    height: 100%;
  .flexCss{
    display: flex;
    .left{
      margin-right: 60px;
      opacity: 0.6;
    }
    .right{
      margin-left: 70px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      h1{
        font-size: 7.5em;
        margin: 15px 0px;
        font-weight: bold;
      }
      h2{
        font-size: 30px;
        font-weight: bold;
      }
      .phone{
        font-size: 16px;
        // margin: 10px 0;
      }
    }
    
  }
}

</style>


// WEBPACK FOOTER //
// src/views/erroPage.vue